export function formatResponseToLabelValue<
  T,
  K1 extends keyof T,
  K2 extends keyof T,
>(
  response: T[],
  labelKey: K1,
  valueKey: K2
): Array<{ name: string; id: string | number }> {
  return response.map((item) => ({
    name: String(item[labelKey]),
    id: item[valueKey] as string | number,
  }));
}
